// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MediaRouteImport } from './routes/media'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResumeRouteImport } from './routes/resume'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WorkRouteImport } from './routes/work'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminContactLogRouteImport } from './routes/admin.contact-log'
import { Route as AdminContentRouteImport } from './routes/admin.content'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminSecurityRouteImport } from './routes/admin.security'
import { Route as AdminSubscribersRouteImport } from './routes/admin.subscribers'
import { Route as AdminToolsRouteImport } from './routes/admin.tools'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogTagsRouteImport } from './routes/blog.tags'
import { Route as ServicesSlugRouteImport } from './routes/services_.$slug'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsContentEngineAdvancedRouteImport } from './routes/tools.content-engine-advanced'
import { Route as ToolsContentSystemScoreRouteImport } from './routes/tools.content-system-score'
import { Route as ToolsSocialProfileScanRouteImport } from './routes/tools.social-profile-scan'
import { Route as WorkIndexRouteImport } from './routes/work.index'
import { Route as WorkSlugRouteImport } from './routes/work.$slug'
import { Route as AdminPostsIdRouteImport } from './routes/admin.posts.$id'
import { Route as AdminPostsNewRouteImport } from './routes/admin.posts.new'
import { Route as BlogTagTagRouteImport } from './routes/blog.tag.$tag'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MediaRoute = MediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResumeRoute = ResumeRouteImport.update({
            id: '/resume',path: '/resume',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const WorkRoute = WorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/admin/analytics',path: '/admin/analytics',getParentRoute: () => rootRouteImport
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/admin/audit',path: '/admin/audit',getParentRoute: () => rootRouteImport
          })
const AdminContactLogRoute = AdminContactLogRouteImport.update({
            id: '/admin/contact-log',path: '/admin/contact-log',getParentRoute: () => rootRouteImport
          })
const AdminContentRoute = AdminContentRouteImport.update({
            id: '/admin/content',path: '/admin/content',getParentRoute: () => rootRouteImport
          })
const AdminInboxRoute = AdminInboxRouteImport.update({
            id: '/admin/inbox',path: '/admin/inbox',getParentRoute: () => rootRouteImport
          })
const AdminSecurityRoute = AdminSecurityRouteImport.update({
            id: '/admin/security',path: '/admin/security',getParentRoute: () => rootRouteImport
          })
const AdminSubscribersRoute = AdminSubscribersRouteImport.update({
            id: '/admin/subscribers',path: '/admin/subscribers',getParentRoute: () => rootRouteImport
          })
const AdminToolsRoute = AdminToolsRouteImport.update({
            id: '/admin/tools',path: '/admin/tools',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogTagsRoute = BlogTagsRouteImport.update({
            id: '/blog/tags',path: '/blog/tags',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services_/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsContentEngineAdvancedRoute = ToolsContentEngineAdvancedRouteImport.update({
            id: '/tools/content-engine-advanced',path: '/tools/content-engine-advanced',getParentRoute: () => rootRouteImport
          })
const ToolsContentSystemScoreRoute = ToolsContentSystemScoreRouteImport.update({
            id: '/tools/content-system-score',path: '/tools/content-system-score',getParentRoute: () => rootRouteImport
          })
const ToolsSocialProfileScanRoute = ToolsSocialProfileScanRouteImport.update({
            id: '/tools/social-profile-scan',path: '/tools/social-profile-scan',getParentRoute: () => rootRouteImport
          })
const WorkIndexRoute = WorkIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WorkRoute
          })
const WorkSlugRoute = WorkSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => WorkRoute
          })
const AdminPostsIdRoute = AdminPostsIdRouteImport.update({
            id: '/admin/posts/$id',path: '/admin/posts/$id',getParentRoute: () => rootRouteImport
          })
const AdminPostsNewRoute = AdminPostsNewRouteImport.update({
            id: '/admin/posts/new',path: '/admin/posts/new',getParentRoute: () => rootRouteImport
          })
const BlogTagTagRoute = BlogTagTagRouteImport.update({
            id: '/blog/tag/$tag',path: '/blog/tag/$tag',getParentRoute: () => rootRouteImport
          })





const WorkRouteChildren = {
  WorkSlugRoute: WorkSlugRoute,WorkIndexRoute: WorkIndexRoute
}

const WorkRouteWithChildren = WorkRoute._addFileChildren(WorkRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,LoginRoute: LoginRoute,MediaRoute: MediaRoute,NewsletterRoute: NewsletterRoute,PrivacyRoute: PrivacyRoute,ResumeRoute: ResumeRoute,ServicesRoute: ServicesRoute,TermsRoute: TermsRoute,WorkRoute: WorkRouteWithChildren,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminAuditRoute: AdminAuditRoute,AdminContactLogRoute: AdminContactLogRoute,AdminContentRoute: AdminContentRoute,AdminInboxRoute: AdminInboxRoute,AdminSecurityRoute: AdminSecurityRoute,AdminSubscribersRoute: AdminSubscribersRoute,AdminToolsRoute: AdminToolsRoute,BlogSlugRoute: BlogSlugRoute,BlogTagsRoute: BlogTagsRoute,ServicesSlugRoute: ServicesSlugRoute,ToolsContentEngineAdvancedRoute: ToolsContentEngineAdvancedRoute,ToolsContentSystemScoreRoute: ToolsContentSystemScoreRoute,ToolsSocialProfileScanRoute: ToolsSocialProfileScanRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,ToolsIndexRoute: ToolsIndexRoute,AdminPostsIdRoute: AdminPostsIdRoute,AdminPostsNewRoute: AdminPostsNewRoute,BlogTagTagRoute: BlogTagTagRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)